"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.guards = exports.Guards = void 0;
const assertEventType_1 = require("./assertEventType");
const types_1 = require("../../types");
const events_1 = require("./events");
const constants_1 = require("../constants");
var Guards;
(function (Guards) {
    Guards["RECEIVED_VALID_CONFIG"] = "@guards/RECEIVED_VALID_CONFIG";
    Guards["RECEIVED_VALID_TYPEAHEAD_SUGGESTIONS"] = "@guards/RECEIVED_VALID_TYPEAHEAD_SUGGESTIONS";
    Guards["RECEIVED_CONFIG_AS_PROP"] = "@guards/RECEIVED_CONFIG_AS_PROP";
    Guards["HAS_VALID_LOGGER_IN_CONTEXT"] = "@guards/HAS_VALID_LOGGER_IN_CONTEXT";
    Guards["HAS_VALID_SUGGESTIONS_IN_CONTEXT"] = "@guards/HAS_VALID_SUGGESTIONS_IN_CONTEXT";
    Guards["TERMS_HAVE_SUFFICIENT_CHARACTER_COUNT"] = "@guards/TERMS_HAVE_SUFFICIENT_CHARACTER_COUNT";
    Guards["MISSING_TERMS_EMPTY_SEARCH_NOT_ALLOWED"] = "@guards/MISSING_TERMS_EMPTY_SEARCH_NOT_ALLOWED";
})(Guards = exports.Guards || (exports.Guards = {}));
exports.guards = {
    [Guards.RECEIVED_VALID_CONFIG]: (_context, event) => {
        (0, assertEventType_1.assertEventType)(event, events_1.Events.DONE_FILL_IN_CONFIG_DEFAULTS);
        return (0, types_1.isConfig)(event.data);
    },
    [Guards.RECEIVED_VALID_TYPEAHEAD_SUGGESTIONS]: (_context, event) => {
        return (0, types_1.isFormattedSuggestionArray)(event.data);
    },
    [Guards.RECEIVED_CONFIG_AS_PROP]: (context) => {
        // just check that there is something in context
        // it is going to get filled in with defaults anyway
        return Boolean(context.serverConfig);
    },
    [Guards.HAS_VALID_LOGGER_IN_CONTEXT]: (context) => {
        const { log } = context;
        return (0, types_1.isLogFunction)(log);
    },
    [Guards.HAS_VALID_SUGGESTIONS_IN_CONTEXT]: (context) => {
        const { typeaheadSuggestions } = context;
        return typeaheadSuggestions &&
            (0, types_1.isFormattedSuggestionArray)(typeaheadSuggestions)
            ? true
            : false;
    },
    [Guards.TERMS_HAVE_SUFFICIENT_CHARACTER_COUNT]: (context) => {
        const { typeaheadTerms } = context;
        if (typeaheadTerms) {
            return typeaheadTerms.length >= constants_1.MIN_CHARACTER_COUNT;
        }
        else {
            return false;
        }
    },
    [Guards.MISSING_TERMS_EMPTY_SEARCH_NOT_ALLOWED]: (context) => {
        const { typeaheadTerms, config } = context;
        return !typeaheadTerms && !(config === null || config === void 0 ? void 0 : config.params.allow_empty_search);
    }
};
//# sourceMappingURL=guards.js.map